import { TopicJob } from 'pages/DodaFront/View/FeaturedJobList/types';

/**
 * タイトル生成のための引数を定義するインターフェース
 */
interface GetTitleArgs {
  /** タイトルテキスト */
  title: TopicJob['title'];
  /** 現在のページ番号 */
  currentPage: number;
}

/**
 * タイトルを生成して返す関数
 *
 * @param {GetTitleArgs} param - 引数オブジェクト
 * @param {string} param.title - タイトルテキスト
 * @param {number} param.currentPage - 現在のページ番号
 * @returns {string | undefined} 生成されたタイトル
 */
export const getTitle = ({ title, currentPage }: GetTitleArgs) => {
  if (!title) return undefined;

  if (currentPage >= 2) return `${currentPage}ページ｜${title}`;
  return title;
};
